export default "__VITE_ASSET__06fe4e69__"